import React from 'react';
import { CheckCircle2, User, X, XCircle } from "lucide-react";

interface Participant {
  id: string;
  name: string;
  email: string;
  phone?: string;
  status: "signed_up" | "attended" | "no_show" | "opt_out";
}

interface ParticipantStatsProps {
  participants: Participant[];
}

export function ParticipantStats({ participants }: ParticipantStatsProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
      <div className="bg-green-50 rounded-lg p-3 border border-green-100">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs text-green-700 font-medium">Attended</p>
            <p className="text-2xl font-bold text-green-800">
              {participants.filter(p => p.status === 'attended').length || 0}
            </p>
          </div>
          <CheckCircle2 className="h-8 w-8 text-green-400" />
        </div>
      </div>
      
      <div className="bg-blue-50 rounded-lg p-3 border border-blue-100">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs text-blue-700 font-medium">Signed Up</p>
            <p className="text-2xl font-bold text-blue-800">
              {participants.filter(p => p.status === 'signed_up').length || 0}
            </p>
          </div>
          <User className="h-8 w-8 text-blue-400" />
        </div>
      </div>
      
      <div className="bg-red-50 rounded-lg p-3 border border-red-100">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs text-red-700 font-medium">No Show</p>
            <p className="text-2xl font-bold text-red-800">
              {participants.filter(p => p.status === 'no_show').length || 0}
            </p>
          </div>
          <XCircle className="h-8 w-8 text-red-400" />
        </div>
      </div>
      
      <div className="bg-orange-50 rounded-lg p-3 border border-orange-100">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs text-orange-700 font-medium">Opted Out</p>
            <p className="text-2xl font-bold text-orange-800">
              {participants.filter(p => p.status === 'opt_out').length || 0}
            </p>
          </div>
          <X className="h-8 w-8 text-orange-400" />
        </div>
      </div>
    </div>
  );
}
